import SharedStore from '@/stores/shared';

export default function storeRoot() {
  return {
    shared: new SharedStore(),
  };
}

export type StoreRoot = ReturnType<typeof storeRoot>;